import React from 'react';
import {
    injectIntl, InjectedIntl, FormattedHTMLMessage, FormattedMessage,
} from 'react-intl';

import {
    VerificationService,
    ErrorId,
    ErrorResponse,
    PoweredByComponent,
    LogoComponent,
    getLogoUrl,
    getLocaleSafely,
    getSafe,
    requestOrganizationConstants as constants,
} from '@sheerid/jslib';
import { ReturnToTimberlandButtonComponent } from '../ReturnToTimberlandButtonComponent';

interface StepErrorProps {
    verificationService: VerificationService;
    errorId?: ErrorId; // eslint-disable-line
    intl?: InjectedIntl; // eslint-disable-line
}

const StepError = ({ verificationService, errorId }: StepErrorProps) => {
    const verificationResponse = verificationService.verificationResponse as ErrorResponse;
    const hasLogo = !!getLogoUrl(verificationService.programTheme);
    let errorIds: ErrorId[] = getSafe(() => verificationResponse.errorIds) || [];
    const invalidCountry = errorId === 'invalidCountry';
    const limitExceededError = verificationResponse.errorIds.includes('verificationLimitExceeded') || verificationResponse.errorIds.includes('docReviewLimitExceeded');

    if (errorId) {
        errorIds = [errorId, ...errorIds]; // Prefer passed in err over any others, so it goes first
    }

    // defaults
    const errorTitle: FormattedMessage.Props = { id: 'error', defaultMessage: 'Error' };
    const logoContainerClass = 'sid-l-horz-center';


    return (
        <div id="sid-step-error" className="sid-l-container">
            <div className="sid-header sid-l-horz-center">
                <div className={logoContainerClass}>
                    { hasLogo
                        ? <LogoComponent verificationService={verificationService} />
                        : (
                            <img
                                className="sid-l-lead-image"
                                alt="design element"
                                src="https://assets-resources.sheerid.com/common/images/2018/icons/circle-exclamation.svg"
                            />
                        )}
                </div>
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage {...errorTitle} />
                </div>
                <div className="sid-header__subtitle sid-l-horz-center sid-l-space-top-md">
                    <div className="sid-error-msg sid-l-horz-center">
                        { errorIds
                            ? (
                                <p>
                                    {
                                        errorIds.map(
                                            errId => (
                                                <FormattedHTMLMessage
                                                    key={errId}
                                                    id={`errorId.${errId}`}
                                                    defaultMessage={errId}
                                                    values={{
                                                        feedbackUrl: constants.FEEDBACK_FORM_URL,
                                                        programId: verificationService.programId || '',
                                                        locale: getLocaleSafely(verificationService.viewModel, verificationResponse).replace('-', '_'),
                                                    }}
                                                />
                                            ),
                                        )
                                    }
                                </p>
                            )
                            : null }
                    </div>

                    {!invalidCountry && !limitExceededError && (
                        <div className="sid-l-space-top-lg">
                            <ReturnToTimberlandButtonComponent />
                        </div>
                    )}
                </div>
            </div>

            <div className="sid-footer sid-l-horz-center sid-l-space-top-xl sid-h-small-text">
                <PoweredByComponent verificationService={verificationService} isCentered />
            </div>
        </div>
    );
};

export const StepErrorComponent = injectIntl(StepError);
